import { AnnouncementSeverity } from '@tabeeb/contracts/microservices/swagger-article-service'

export const AnnouncementSeverityDisplayName: Record<AnnouncementSeverity, string> = {
  [AnnouncementSeverity.Information]: 'Information',
  [AnnouncementSeverity.Notification]: 'Notification',
  [AnnouncementSeverity.Alert]: 'Alert',
}

export { AnnouncementSeverity }
